<template>
	<LabeledFieldLayout
		class="labeled-input-field"
		:is-valid="isValid"
	>
		<template #label>
			<slot name="label">{{ label }}</slot>
		</template>
		<template #label-right>
			<slot name="label-right"></slot>
		</template>
		<template #hint>
			<slot name="hint">{{ hint }}</slot>
		</template>
		<template #default>
			<TeamingTextbox
				:class="inputClassName"
				:debounce-input-duration="debounceInputDuration"
				:disabled="disabled"
				:focus="focus"
				:is-valid="isValid"
				:left-icon="leftIcon"
				:name="name"
				:placeholder="placeholder"
				:right-icon="rightIcon"
				:selection="selection"
				:value="value"
				@blur="onBlur"
				v-on="bubble(
					`input`,
					`enterKey`,
					`focus`,
					`paste`
				)"
			>
				<template v-if="$slots[ 'left-icon' ] && !leftIcon" #left-icon>
					<slot name="left-icon"></slot>
				</template>
				<template v-if="$slots[ 'right-icon' ] && !rightIcon" #right-icon>
					<slot name="right-icon"></slot>
				</template>
			</TeamingTextbox>
		</template>
	</LabeledFieldLayout>
</template>

<script>
import EventsMixin from "../../mixins/EventsMixin";
import TeamingTextbox from "../TeamingTextbox";
import LabeledFieldLayout from "./LabeledFieldLayout.vue";

export default {
	name: "LabeledInputField",
	mixins: [ EventsMixin, ],
	emits: [
		"input",
		"enterKey",
		"focus",
		"blur",
		"paste",
	],
	components: {
		LabeledFieldLayout,
		TeamingTextbox,
	},
	props: {
		name: {
			type: String,
			default: "",
		},
		hint: {
			type: String,
			default: "",
		},
		label: {
			type: String,
			default: "",
		},
		placeholder: {
			type: String,
			default: "",
		},
		value: {
			type: String,
			default: "",
		},
		inputClassName: {
			type: String,
			default: "",
		},
		isValid: {
			type: Boolean,
			default: true,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		/** @deprecated: use #left-icon slot */
		leftIcon: {
			type: Array,
			default: () => undefined,
		},
		/** @deprecated: use #right-icon slot */
		rightIcon: {
			type: Array,
			default: () => undefined,
		},
		focus: {
			type: Boolean,
			default: false,
		},
		selection: {
			type: Array,
			default: () => [],
		},
		/** This is terrible, but some of our legacy controls rely on this behavior. */
		blurIsInput: {
			type: Boolean,
			default: true,
		},
		debounceInputDuration: {
			type: Number,
			default: 0,
		},
	},
	methods: {
		onBlur( e ) {
			// This is terrible, but some of our legacy controls rely on this behavior.
			if ( this.blurIsInput ) {
				this.$emit( "input", e );
			} else {
				this.$emit( "blur", e );
			}
		},
	},
};
</script>

<style lang="scss" scoped></style>
